import { ROUTER } from '../helpers/RouterApi';
import { BackEndHelper } from '../helpers/BackEndHelper';

export const RssCrawlResultServices = {
    getList,
};

function getList() {
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_RSSCRAWLRESULT);
}